import { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

import Loader from 'src/components/common/loader';
import Tabs from 'src/components/common/tabs';
import TextError from 'src/components/ui/text-error';
import PaypalForm from '../paypal-form';
import StripeForm from '../stripe-form';

import paymentStore from 'src/stores/payment-store';

import { StripeProvider } from 'src/contexts';
import { IS_STRIPE, PAYPAL_CLIENT_ID } from 'src/constants';

import './payment-form.scss';

const PaymentForm = observer(() => {
  const {
    activeTab,
    isPaymentLoading,
    isPaypalSelected,
    paymentFormError,
    paymentsTabs,
    clearForm,
  } = paymentStore;
  const formRef = useRef<HTMLDivElement>(null);
  const [form, setForm] = useState<HTMLDivElement | null>(null);
  const [minHeight, setMinHeight] = useState(0);

  useEffect(() => {
    if (!formRef.current) {
      return;
    }

    setForm(formRef.current);

    const resizeObserver = new ResizeObserver(() => {
      setMinHeight((prevValue) => Math.max(prevValue, formRef.current?.clientHeight ?? 0));
    });
    resizeObserver.observe(formRef.current);

    return () => {
      resizeObserver.disconnect();
      clearForm();
    };
  }, [clearForm]);

  return (
    <div className="payment-form" ref={formRef} style={{ minHeight: `${minHeight}px` }}>
      <div className="payment-form__container">
        {IS_STRIPE && PAYPAL_CLIENT_ID && <Tabs activeTab={activeTab} tabs={paymentsTabs} />}
        <div className="payment-form__wrapper">
          {form &&
            (isPaypalSelected ? (
              <PaypalForm form={form} />
            ) : (
              <StripeProvider>
                <StripeForm form={form} />
              </StripeProvider>
            ))}
          {paymentFormError && <TextError textError={paymentFormError} />}
        </div>
      </div>
      {isPaymentLoading && <Loader className="loader_position_overlay payment-form__loader" />}
    </div>
  );
});

export default PaymentForm;
